import { render, staticRenderFns } from "./MemberCenter.vue?vue&type=template&id=35d91da6&scoped=true&lang=pug&"
import script from "./MemberCenter.vue?vue&type=script&lang=js&"
export * from "./MemberCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d91da6",
  null
  
)

export default component.exports